var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.381,
    height: 32.381,
    rx: 16.1905,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.934 7.85742V10.3574M12.434 7.85742V10.3574M16.184 7.85742V10.3574",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0172 9.10742H15.3506C12.6007 9.10742 11.2258 9.10742 10.3715 9.9617C9.51721 10.816 9.51721 12.1909 9.51721 14.9408V18.6908C9.51721 21.4406 9.51721 22.8155 10.3715 23.6698C11.2258 24.5241 12.6007 24.5241 15.3506 24.5241H17.0172C19.7671 24.5241 21.142 24.5241 21.9963 23.6698C22.8506 22.8155 22.8506 21.4406 22.8506 18.6908V14.9408C22.8506 12.1909 22.8506 10.816 21.9963 9.96169C21.142 9.10742 19.7671 9.10742 17.0172 9.10742Z",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8506 18.6908H16.1839M12.8506 15.3574H19.5173",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate3);
export default __webpack_public_path__ + "static/media/create-3.1bb51f298cea8ee758fe6013a372dc2d.svg";
export { ForwardRef as ReactComponent };